import { toCacheKey } from '@pinia/colada';

export const useSearchResultsQueryState = () => {
  const criteriaStore = useSearchCriteriaStore();
  const filtersStore = useSearchResultFiltersStore();

  // Committed key, mirroring list.vue: the live form would watch another entry than the query writes.
  const {
    asyncStatus: mainAsyncStatus,
    status: mainStatus,
    isPending: mainIsPending,
  } = useQueryState(() => ['search-results', toCacheKey([criteriaStore.committedCriteriaKey])]);
  const {
    asyncStatus: filteringAsyncStatus,
    status: filteringStatus,
    isPending: filteringIsPending,
  } = useQueryState(() => [
    'search-results',
    toCacheKey([criteriaStore.committedCriteriaKey]),
    toCacheKey([filtersStore.searchedFilteringCriteriaKey]),
  ]);

  // The form renders above the list: on the server this entry does not exist yet, the client hydrates it.
  const loading = computed(
    () => criteriaStore.searchRequested && (mainIsPending.value || mainAsyncStatus.value === 'loading'),
  );
  // The background search: the BFF call a filter change triggers, which adds offers to a list already shown.
  const filteringLoading = computed(
    () => filtersStore.active && (filteringIsPending.value || filteringAsyncStatus.value === 'loading'),
  );
  const queryLoading = computed(() => loading.value || filteringLoading.value);

  // A settled query in error (GDS/network) is not a valid quote — the caller must not arm the timer on it.
  const error = computed(() => mainStatus.value === 'error' || filteringStatus.value === 'error');

  return { loading, filteringLoading, queryLoading, error };
};
